import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, UserPlus, ClipboardList, UtensilsCrossed, Settings, Fingerprint, BarChart3 } from 'lucide-react';
import './Layout.css';

const Sidebar = ({ isOpen, onClose }) => {
  const navItems = [
    { name: 'Dashboard', path: '/', icon: <LayoutDashboard size={20} /> },
    { name: 'Orders', path: '/orders', icon: <ClipboardList size={20} /> },
    { name: 'Menu', path: '/menu', icon: <UtensilsCrossed size={20} /> },
    { name: 'Employees', path: '/employees', icon: <Users size={20} /> },
    { name: 'Attendance', path: '/attendance', icon: <Fingerprint size={20} /> },
    { name: 'Staff Reports', path: '/reports', icon: <BarChart3 size={20} /> },
    { name: 'Salary Status', path: '/salary', icon: <UserPlus size={20} /> },
    { name: 'Settings', path: '/settings', icon: <Settings size={20} /> },
  ];

  return (
    <>
      {isOpen && <div className="sidebar-backdrop" onClick={onClose}></div>}
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-brand">
          <img className='logo' src="../logo-NoBG.png" alt="logo" />
        </div>
        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={onClose}
              className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}
            >
              {item.icon}
              <span>{item.name}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
